/** The signed-in user, as the app learned it from `/api/session`, for the harness shell's account launcher. */
import { create } from "zustand";

export const useAccount = create<{ user?: string | undefined }>(() => ({}));

/** Up to two initials for an avatar. */
export function initialsOf(user: string): string {
  return user.trim().split(/\s+/u).slice(0, 2).map(part => part[0] ?? "").join("").toUpperCase() || "A";
}
